import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'

Vue.use(Vuex)

// 应用初始状态
const state = {
  token: null,
  userid: null,
  userinfo: null,
  signUpList: []
}


// 定义所需的 mutations
const mutations = {
  SETTOKEN( state, value){
    state.token = value
  },
  SETUSERID(state, value){
    state.userid = value
  },
  SETUSERINFO(state, value){
    state.userinfo = value
  },
  REMOVEDATA(state){
    state.token = null
    state.userid = null
    state.userinfo = null
    localStorage.setItem('userinfo', '')
  },
  SIGNUPLIST(state, value){
    state.signUpList = value
  },
  CLEARSIGNUPLIST(state){
    state.signUpList = []
  },

}

// 创建 store 实例
export default new Vuex.Store({
  actions,
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/store.js